import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';
import URL from '@/creditflowresearch/Router/urlConstants';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';

interface IFilters {
  products?: string | string[],
  regions?: string | string[],
}

const getScorecardsBreadcrumbs = (filters: IFilters, leagueType: string, companyName: string): IBreadcrumb[] => [
  getMarketOverviewBreadcrumbsRoute(filters),
  {
    title: 'League Tables',
    url: leagueType === 'underwriter'
      ? `${ URL.LEAGUE_TABLE_UNDERWRITERS }?products=${ filters.products }&regions=${ filters.regions }`
      : `${ URL.LEAGUE_TABLE_RATING_AGENCIES }?products=${ filters.products }&regions=${ filters.regions }`,
  },
  {
    title: companyName,
    isActive: true,
  },
];

export default getScorecardsBreadcrumbs;
